import { FarmsDirectoryWrapper } from "./farms-directory.style";
import { FarmsDirectorySection } from "./sections/farms-directory.section";

export const FarmsDirectoryPage = () => <FarmsDirectoryWrapper><FarmsDirectorySection /></FarmsDirectoryWrapper>;
